module.exports = ".mat-primary{background-color:transparent}\n"